<template>
  <div class="signature">
    <div v-if="image" class="sign-image">
      <i class="el-icon-close delete-image" @click="clearImage"></i>
      <img :src="image" />
    </div>
    <sign-popover
      v-else
      ref="popover"
      :placeholder="placeholder"
      :disabled="disabled"
      class="sign-popover"
      @output="output"
      @change="changeImage"
    ></sign-popover>
  </div>
</template>
<script>
import { getUrlByPath } from "@/utils/uploadFile"
import SignPopover from "@/components/BaseComponents/SignPopover"
export default {
  name: "signature",
  props: {
    placeholder: String,
    disabled: Boolean,
    value: Object
  },
  components: {
    SignPopover
  },
  data() {
    return {
      image: ""
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.image = getUrlByPath(this.value?.path)
      },
      immediate: true
    }
  },
  methods: {
    clearImage() {
      this.output()
      this.changeImage()
    },
    changeImage(image) {
      this.image = image
    },
    output(file) {
      this.$emit("output", file)
    },
    focus() {
      this.$refs.popover.focus()
    }
  }
}
</script>
<style lang="scss" scoped>
.signature {
  .sign-image {
    display: flex;
    flex-flow: column;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 1px;
    .delete-image {
      text-align: right;
      cursor: pointer;
      padding: 6px;
    }
  }
  .sign-popover {
    ::v-deep {
      .el-input__prefix {
        left: 3px;
        .icon {
          width: 25px;
          text-align: center;
          .svg-icon {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
